module.exports = __webpack_public_path__ + "static/img/cha-page-08.5825e7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-page-08.png
// module id = sw13
// module chunks = 1